<template>
  <dl>
    <template v-for="({ label, value, maxValue, minLabel, maxLabel }, i) in data" :key="i">
      <dt :id="`meter-label-${i}`" class="pb-1 text-sm fw-medium" :class="{ 'mt-4': i }">
        {{ label }}
      </dt>
      <dd>
        <vf-meter
          :aria-labelledby="`meter-label-${i}`"
          aria-valuemin="1"
          :max-label="maxLabel"
          :max-value="maxValue ? +maxValue : undefined"
          :min-label="minLabel"
          :value="value ? +value : undefined"
        />
      </dd>
    </template>
  </dl>
</template>

<script setup lang="ts">
import type { ProductDetailContentScale } from '#types/product'

defineProps<{
  data: ProductDetailContentScale[]
}>()
</script>
